// const moment = require('moment')

const formRows = [
  {
    span: 24,
    label: '服务名称',
    component: 'AInput',
    placeholder: '请输入服务名称',
    prop: 'name',
    allowClear: true
  },
  {
    span: 24,
    label: '服务类型',
    component: 'ARadioGroup',
    prop: 'thirdServiceType',
    placeholder: '请选择服务类型',
    radioList: [
      { label: '知识产权', value: '1' },
      { label: '资助认证', value: '2' },
      { label: '法律服务', value: '3' },
      { label: '金融服务', value: '4' },
      { label: '培训服务', value: '5' },
      { label: '信息服务', value: '6' }
    ]
  },
  {
    span: 24,
    label: '配图',
    component: 'AUpload',
    prop: 'picPath' // 首图
  },
  {
    span: 24,
    label: '服务简介',
    component: 'ATextArea',
    prop: 'summary'
  },
  {
    span: 24,
    label: '服务区域',
    component: 'ARadioGroup',
    placeholder: '请输入区域',
    prop: 'area',
    radioList: [
      { label: '北京', value: '北京' },
      { label: '上海', value: '上海' },
      { label: '天津', value: '天津' },
      { label: '重庆', value: '重庆' },
      { label: '江苏', value: '江苏' },
      { label: '广东', value: '广东' },
      { label: '山东', value: '山东' },
      { label: '浙江', value: '浙江' },
      { label: '四川', value: '四川' },
      { label: '河北', value: '河北' },
      { label: '湖北', value: '湖北' },
      { label: '福建', value: '福建' },
      { label: '辽宁', value: '辽宁' },
      { label: '河南', value: '河南' },
      { label: '安徽', value: '安徽' },
      { label: '湖南', value: '湖南' },
      { label: '陕西', value: '陕西' },
      { label: '广西', value: '广西' },
      { label: '江西', value: '江西' },
      { label: '山西', value: '山西' },
      { label: '黑龙江', value: '黑龙江' },
      { label: '吉林', value: '吉林' },
      { label: '贵州', value: '贵州' },
      { label: '云南', value: '云南' },
      { label: '新疆', value: '新疆' },
      { label: '甘肃', value: '甘肃' },
      { label: '内蒙古', value: '内蒙古' },
      { label: '海南', value: '海南' },
      { label: '宁夏', value: '宁夏' },
      { label: '青海', value: '青海' },
      { label: '西藏', value: '西藏' },
      { label: '其他地区', value: '其他地区' }
    ]
  },
  {
    span: 24,
    label: '服务详情',
    component: 'RichTextEdit',
    prop: 'detail'
  },
  {
    span: 24,
    label: '服务案例',
    component: 'RichTextEdit',
    prop: 'case'
  }
]

const formRules = {
  name: [
    { required: true, message: '服务名称不能为空', trigger: 'blur' },
    { min: 1, max: 100, message: '输入的字数不能超过100个', trigger: 'blur' }
  ],
  thirdServiceType: [
    { required: true, message: '服务类型不能为空', trigger: ['blur'] }
  ],
  picPath: [{ required: true, message: '配图不能为空', trigger: ['blur'] }],
  summary: [{ required: true, message: '简介不能为空', trigger: ['blur'] }],
  area: [{ required: true, message: '区域不能为空', trigger: ['blur'] }]
  // detail: [
  //   { required: true, message: '详情不能为空', trigger: ['blur'] }
  // ],
  // case: [
  //   { required: true, message: '案例不能为空', trigger: ['blur'] }
  // ],
}

const formInfo = [
  { label: '服务名称', value: '-', key: 'name' },
  { label: '服务类型', value: '-', key: 'thirdServiceTypeStr' },
  { label: '服务区域', value: '-', key: 'area' },
  { label: '服务简介', value: '-', key: 'summary' },
  { label: '服务详情', value: '-', key: 'detail', isVHtml: true },
  { label: '服务案例', value: '-', key: 'case', isVHtml: true }
]

const userInfo = [
  { label: '发布人', value: '-', key: 'userName' },
  { label: '机构', value: '-', key: 'enpName' },
  { label: '手机', value: '-', key: 'phoneNumber' },
  { label: '电话', value: '-', key: 'enpPhone' },
  { label: '邮箱', value: '-', key: 'email' }
]

module.exports = {
  formRows,
  formRules,
  formInfo,
  userInfo
}
